<template>
    <div class="latest-news-section pt-100 pb-70">
        <div class="container">
            <!-- Section Title Start -->
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8 text-center">
                    <div class="sec-title">
                        <h2>Publikationen</h2>
                        <p></p>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
            <!-- Section Title End -->
            <div class="row">
                <div class="col-md-4 col-sm-12 col-xs-12" v-for="(publication, key) in publications" :key="key">
                    <NewsItem :image="publication.image" :author="publication.author" :title="publication.title"
                              :link="publication.link" :desc="publication.desc"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NewsItem from './NewsItem';

    export default {
        name: 'News',
        components: {
            NewsItem
        },
        data () {
            return {
                publications: [
                    {
                        image: 'images/news/cover.jpg',
                        author: 'Agron Lamaj',
                        title: 'Die Rechtliche Absicherung von ausländischen Investitionen in Albanien',
                        link: 'https://www.amazon.com/Absicherung-Direktinvestitionen-internationalen-Wirtschafts-u-Steuerrecht/dp/3631315651',
                        desc: '1996, Peter Lang Verlag (Frankfurt am Main)'
                    },
                    {
                        image: 'images/news/cover.jpg',
                        author: 'Agron Lamaj',
                        title: 'Grundsätze des albanischen Schuldrechts',
                        link: 'https://www.amazon.com/Absicherung-Direktinvestitionen-internationalen-Wirtschafts-u-Steuerrecht/dp/3631315651',
                        desc: '2014, Tirana'
                    },
                    {
                        image: 'images/news/cover.jpg',
                        author: 'Agron Lamaj',
                        title: 'Albanisches Handelsrecht',
                        link: 'https://www.amazon.com/Absicherung-Direktinvestitionen-internationalen-Wirtschafts-u-Steuerrecht/dp/3631315651',
                        desc: '2015, Tirana'
                    },
                ]
            };
        },
        methods: {}
    };
</script>
